import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, FileText, Shield, Users, Coins, Phone } from "lucide-react";
import { useAuth } from "../lib/auth";
import LegalDoc from "../components/LegalDoc";
import TERMS from "../content/terms";
import PRIVACY from "../content/privacy";
import COMMUNITY from "../content/community";
import GOLDLY, { CONTACT } from "../content/goldly";

const TABS = [
  { id: "terms", label: "Terms & Conditions", icon: FileText, text: TERMS },
  { id: "privacy", label: "Privacy Policy", icon: Shield, text: PRIVACY },
  { id: "community", label: "Community Guidelines", icon: Users, text: COMMUNITY },
  { id: "goldly", label: "Goldly Policy", icon: Coins, text: GOLDLY },
  { id: "contact", label: "Contact Us", icon: Phone, text: CONTACT },
];

export default function Policy() {
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const { user } = useAuth();
  const active = TABS.find(t => t.id === params.get("tab")) || TABS[0];
  useEffect(() => { window.scrollTo(0, 0); }, [active.id]);

  return (
    <div className="px-4 py-6 pb-24 max-w-2xl mx-auto" data-testid="policy-page">
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => (window.history.length > 1 ? nav(-1) : nav("/"))} data-testid="policy-back"><ArrowLeft className="w-5 h-5"/></button>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">HIFIREELS POLICY</h1>
      </div>
      <div className={`sticky ${user ? "top-16" : "top-0"} z-10 -mx-4 px-4 py-2 bg-[#0B0F19]/90 backdrop-blur grid grid-cols-3 gap-1.5 mb-5`} data-testid="policy-tabs">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setParams({ tab: t.id }, { replace: true })} data-testid={`policy-tab-${t.id}`}
            className={`flex flex-col items-center gap-1 py-2 px-1 rounded-2xl text-[11px] font-bold leading-tight text-center border active:scale-95 ${
              active.id === t.id ? "bg-[#FF7A00] text-black border-[#FF7A00]" : "bg-white/5 text-white/80 border-white/10"}`}>
            <t.icon className="w-4 h-4"/>{t.label}
          </button>
        ))}
      </div>
      <h2 className="font-outfit font-extrabold text-xl mb-4" data-testid="policy-title">{active.label}</h2>
      <LegalDoc key={active.id} text={active.text}/>
    </div>
  );
}
